import { RadioBar } from './components/RadioBar';
import { SocialCard } from './components/SocialCard';
import { LinkHub } from './components/LinkHub';

export function Home() {
  return (
    <>
      {/* pinned top piece: radio player + profile card */}
      <header className="topfix">
        <RadioBar />
        <div className="topfix__inner">
          <SocialCard />
        </div>
      </header>
      <main className="page">
        <LinkHub />
      </main>
    </>
  );
}
